module.exports = __webpack_public_path__ + "b51200a7.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_maximizar.png
// module id = 1160
// module chunks = 0 1 2